import * as React from "react";
import { FormStylingHelpers } from "../formcontrols/helpers/FormStylingHelpers";

export interface SimpleTextProps {
  formFieldDefinition: any; 
}

export const SimpleText = (props: SimpleTextProps) => <div className="form-group">
        <label>{props.formFieldDefinition.label}</label>
        <p>{props.formFieldDefinition.explanation !== undefined && props.formFieldDefinition.explanation !== "" ? props.formFieldDefinition.explanation : props.formFieldDefinition.text}</p>
  </div>;

